<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <router-link class="py-5 flex-center" to="/">
        <img class="login-logo" :src="logoimg.img" />
      </router-link>
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <va-tabs v-model="tabIndex" center>
            <va-tab>{{ $t('auth.login') }}</va-tab>
          </va-tabs>

          <va-separator />

          <div class="pa-3">
            <router-view />
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
const tabs = ["login"];

export default {
  name: "AuthLayout",
  data() {
    return {
      selectedTabIndex: 0,
      tabTitles: ["login"],
      logoimg: {
        title: "Logo OPEF",
        img: require("@/assets/opef_med_bleu.png")
      }
    };
  },
  computed: {
    tabIndex: {
      set(tabIndex) {
        this.$router.push({ name: tabs[tabIndex] });
      },
      get() {
        return tabs.indexOf(this.$route.name);
      }
    }
  }
};
</script>

<style lang="scss">
.login-logo {
  height: 15rem;
  width: 15rem;
}
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to right, #ffffff, #f5f5f5);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}
</style>
